export default __webpack_public_path__ + "static/210528_夏日角色熱更預告_kr-e011460545e53fd0aee2ce5e6d10ad3d.png";